// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One column on phones, fields in pairs from tablet width up (description on its own row) */
.part-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  padding-bottom: var(--ion-safe-area-bottom);
}
@media (min-width: 576px) {
  .part-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.part-form ion-input,
.part-form ion-select {
  --border-radius: 10px;
  --highlight-color-focused: var(--ion-color-primary);
  min-height: 56px;
}
.part-form__full {
  grid-column: 1/-1;
}`, "",{"version":3,"sources":["webpack://./src/components/form-components/form-edit-environment/form-edit-environment.component.scss"],"names":[],"mappings":"AAAA,4FAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,2CAAA;AACF;AACE;EANF;IAOI,gDAAA;EAEF;AACF;AAAE;;EAEE,qBAAA;EACA,mDAAA;EACA,gBAAA;AAEJ;AACE;EACE,iBAAA;AACJ","sourcesContent":["/* One column on phones, fields in pairs from tablet width up (description on its own row) */\n.part-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 16px;\n  padding-bottom: var(--ion-safe-area-bottom);\n\n  @media (min-width: 576px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  ion-input,\n  ion-select {\n    --border-radius: 10px;\n    --highlight-color-focused: var(--ion-color-primary);\n    min-height: 56px;\n  }\n\n  &__full {\n    grid-column: 1 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
